<template>
  <div class="native-upload">
    <div class="img-item img-item-0" v-if="staticSmallImg_mutiOneCase">
          <van-image width="100%" lazy-load :src="staticSmallImg_mutiOneCase" @click="showViewImage(staticBigImg_mutiOneCase)">
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
            <!--文本为：加载失败-->
            <template v-slot:error>上传失败</template>
          </van-image>
      </div>
    <div v-for="(item,index) in children" :key="index" class="img-item">
      <!-- <div  v-if="item.status === 0" class="uploader" @click="takePhoto">
        <div class="img-tips">
          <img :src="require('_image/common/photo.png')" alt="" />
        </div>
        <div class="desc">点击拍照</div>
      </div> -->
    <!-- 上传状态 1上传中  2上传成功   3上传失败 -->
      <div class="mask" v-if="item.status !== 0" @click="handleClickMask(item,index)">
        <!-- <van-image class="pre-image" :src="swipeList[index]?swipeList[index]:''" /> -->
        <van-image class="pre-image" :src="item.preImg" />
        <!--文本为：上传中...-->
        <van-loading
          class="loading"
          type="spinner"
          v-if="item.status === 1"
          size="24px"
          vertical
          >Đang tải lên…</van-loading>

        <div class="success" v-if="item.status === 2">
          <span class="icon"><img :src="require('../../assets/image/settleAccount/gou3.png')" alt=""></span>
          <!--文本为：上传成功，点击查看-->
          <span class="desc_icon">Tải lên thành công, click vào kiểm tra</span>
        </div>
        <div class="failure" v-if="item.status === 3">
          <span class="icon">!</span>
          <!--文本为：点击重新上传-->
          <span class="desc_icon">Click để tải lại</span>
        </div>
        <div class="close" v-if="item.status !== 0" @click.stop="close(index,item)" >
          <span class="close-icon">x</span>
        </div>
      </div>
    </div>

    <div class="uploader" @click="takePhoto" v-if="maxCount>1 && children.length<maxCount">
        <div class="img-tips">
          <img :src="require('../../assets/image/settleAccount/photo.png')" alt="" />
        </div>
        <!--文本为：点击重新上传-->
        <div class="desc">Click để chụp hình</div>
      </div>

    <van-image-preview
      v-model="showImagePreview"
      :images="images"
    ></van-image-preview>


  </div>
</template>

<script>
export default {
  name: "nativeUpload",
  props: {
    maxCount: {
      type: Number,
      default: 1,
    },
    children:{
      type:Array,
      default:()=>[]
    },
    swipeList:{
      type:Array,
      default:()=>[]
    },
    delKeyList:{
      type:Array,
      default:()=>[]
    },
    staticSmallImg_mutiOneCase: {
      type: String,
      default: '',
    },
    staticBigImg_mutiOneCase: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      showImagePreview: false,
      images: [],
    };
  },
  methods: {
    // 预览图片
    showViewImage(img){
      this.showImagePreview = true
      this.images = Array.isArray(img) ? img : [img]
    },
    takePhoto() {
      // this.$toast("正在打开相机");
      const photoIndex = this.children?this.children.length:0
      let key=null
      let delKey =null
      if(photoIndex >-1){
        key = this.children[photoIndex]?this.children[photoIndex].key:null
        // debugger
        if(this.delKeyList&&this.delKeyList.length >0 ){
          delKey = this.delKeyList[0]
        }
      }
      this.$emit("takePhoto", {key,photoIndex,delKey})
    },
    handleClickMask(item,index){
      // debugger
      if(item.status === 2) {
        // 上传成功，查看预览图
        this.showImagePreview = true
        this.images = []
        this.images.push(item.preImg)
      }
      if(item.status === 3) {
        // 上传失败，重新上传
        // debugger
        const photoIndex = index
        // const key = item.type + (index + 1)
        this.$emit('takePhoto',{key:item.key,photoIndex},3)
      }
    },
    // 删除图片
    close(index,item){
      // debugger
      const {fileId,key,type}= item
      const photoIndex = index
      const params = {
        key,
        photoIndex,
        id:fileId,
        type
      };
      this.$emit('delete',params)
    }
  },
};
</script>

<style lang="less" scoped>
.native-upload {
  width: 100%;
  background: #fff;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .img-item {
    margin-bottom: 9px;
    width: 150px;
  }
  .img-item-0{
    margin-bottom: 0;
  }
  .uploader {
    width: 150px;
    height: 150px;
    display: flex;
    flex-direction: column;
    background: #f2f2f2;
    align-items: center;
    justify-content: center;
    .img-tips {
      width: 48px;
      height: 35px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .desc {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #999;
      margin-top: 10px;
    }
  }
  .mask {
    width: 100%;
    background: #000;
    height: 150px;
    position: relative;
    .close{
      padding: 5px;
      color: #fff;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 3;
      .close-icon{
        display: block;
        width: 18px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        background: #000;
        color: #fff;
        font-size: 13px;
        border-radius: 50%;

      }
    }
    .pre-image,.loading,.success,.failure {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      z-index: 2;
    }
    .pre-image {
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0.5;
    }
    .success, .failure{
      font-size: 12px;
      color: #fff;
      font-size: 600;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .icon {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: var(--theme-color);
        line-height: 20px;
        text-align: center;
        padding: 4px;
        margin-bottom: 5px;
        img {
          width: 100%;
          height: auto;
          margin-top: 1px;
          display: block;
        }
      }
      .desc_icon {
        display: block;
        width: 150px;
        text-align: center;
      }
    }
    .failure {
      .icon {
        background: #ff6248;
        padding:0 5px ;
      }
    }
  }
}
</style>
